{
  "ffLibraryVersionCode": 1,
  "ffLibraryVersionName": "1.0.2-beta",
  "ffLibraryLanguage": "Javascript",
  "minimumPollFrequencySeconds": 60
}
